































































import Vue from 'vue'
import HomeIcon from '~/static/icons/home.svg?inline'

export type PathItem = {
  pageName: string
  url?: string
}

export default Vue.extend({
  name: 'Breadcrumbs',
  components: {
    HomeIcon
  },
  props: {
    pathList: {
      type: Array as () => PathItem[],
      default: [],
      required: true
    }
  },
  data() {
    const activePage = [...this.pathList].reverse()[0]
    const parentPages = this.pathList.slice(0, -1)
    return {
      activePage,
      parentPages
    }
  }
})
